import { privateApi } from '../config/api';

class Btc1HistoryService {
  constructor() {
    this.baseURL = '/v1/btc1-history';
  }

  /**
   * Get all BTC1-related transaction history
   * @param {Object} params - Query parameters
   * @param {string} params.type - Transaction type: 'all', 'swap', 'deposit', 'fiat_request'
   * @param {number} params.limit - Number of transactions to return (default: 20)
   * @param {number} params.page - Page number (default: 1)
   * @returns {Promise<Object>} Transaction history data with pagination info
   */
  async getTransactionHistory(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.type) queryParams.append('type', params.type);
      if (params.limit) queryParams.append('limit', params.limit.toString());
      if (params.page) queryParams.append('page', params.page.toString());
      
      const response = await privateApi.get(`${this.baseURL}/?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching BTC1 transaction history:', error);
      throw error.response?.data || error.message;
    }
  }

  /**
   * Get quick swap transaction history specifically
   * @param {Object} params - Query parameters
   * @param {number} params.limit - Number of swaps to return (default: 20)
   * @returns {Promise<Object>} Quick swap history data
   */
  async getQuickSwapHistory(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.limit) queryParams.append('limit', params.limit.toString());
      
      const response = await privateApi.get(`${this.baseURL}/swaps/?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quick swap history:', error);
      throw error.response?.data || error.message;
    }
  }

  /**
   * Get transaction history for a specific type
   * @param {string} type - Transaction type: 'swap', 'deposit', 'fiat_request'
   * @param {number} limit - Number of transactions to return
   * @returns {Promise<Array>} Array of transactions
   */
  async getHistoryByType(type, limit = 20) {
    try {
      const response = await this.getTransactionHistory({ type, limit });
      return response.transactions || [];
    } catch (error) {
      console.error(`Error fetching ${type} history:`, error);
      return [];
    }
  }
}

export default new Btc1HistoryService();
